import React from 'react'
import { Col, Row } from 'reactstrap'
import './Term.css'

export const Terms = () => {
    return (
        <div id='termsConditions'>
            <Row>
                <Col xs={12}>
                    <div>
                        <div className='common-title'>TERMS AND CONDITIONS</div>
                        <p>This document contains Terms and Conditions for appointment of DISTRIBUTOR/ DEALER in respect of
                            products manufactured/marketed/Distributed by Agrocel Industries Pvt. Ltd. (AIPL). The DISTRIBUTOR/
                            DEALER appointed of the AIPL will have to agree and abide by these Terms & Conditions:</p>
                        <ul>
                            <li>DISTRIBUTOR/ DEALER undertake to sell AIPLS products only in the original packing and with the
                                original labels affixed and not to alter and tamper with packing supplied by the AIPL.</li>
                            <li>DISTRIBUTOR/ DEALER will ensure and protect copyrights, trademarks, patents, intellectual properties and
                                other proprietary rights of the AIPL and its products.</li>
                            <li>AIPL shall sell and DISTRIBUTOR / DEALER shall purchase the PRODUCT as per the price list released
                                by AIPL from time to time.</li>
                        </ul>
                        <b>Selling Price:</b>
                        <p>The DISTRIBUTOR/ DEALER agree:</p>
                        <p>Not to sell the products below the price invoiced to them by the AIPL.</p>
                        <ul>
                            <li>Not to sell the products below the dealer price indicated by AIPL and announced in the market.</li>
                            <li>To pass on discounts / schemes to retailers as per the AIPL’S guidelines.</li>
                            <li>That AIPL shall have the right to modify the prices at any time and the AIPL shall not be held
                                responsible for any loss/damage caused due to such revision in prices.</li>
                        </ul>

                        <b>Territory /Area of Operation:</b>
                        <p>Territory means the geographical area set forth in Schedule 1(attached). If parties agree to include additional
                            geographical areas in the Territory during the term of this Agreement, the same will be added.</p>
                        <p>This area is not exclusively assigned to DISTRIBUTOR/ DEALER and AIPL shall be free to sell the products
                            directly/ or through Sole Distributor to any other person/ firm in the territory or to appoint other DISTRIBUTOR/
                            DEALER within the territory.</p>

                        <b>Non- Competition:</b>
                        <p>DISTRIBUTOR/ DEALER agree that during the term of this agreement, THEY WILL NOT SELL ANY OF THE
                            AIPL PRODUCTS IN TERRITORIES NOT ASSIGNED TO THEM AND SPOIL THE MARKET. THEY
                            AGREE TO MAINTAIN TERROTORY DISCIPLINE.</p>

                        <b>Terms of payment:</b>
                        <p>DISTRIBUTOR/ DEALER agrees to make payment for the products purchased in accordance with the terms of
                            payment stated in the invoices AND PRICE TERMS .If payments are not made within the period stipulated in the
                            Invoice, AIPL shall, without prejudice to any other rights and remedies including the right to terminate
                            Distributorship/ Dealership be entitled to charge interest on the amount at 24% per annum from the date of expiry
                            of period of credit until the date of payment. AIPL RESERVES THE RIGHT TO DISCONTINUE SUPPLY OF
                            MATERIAL TO PARTIES HAVING OVERDUE OUTSTANDINGS.</p>

                        <b>Dishonouring of Cheques/Instruments:</b>
                        <p>In case of any cheque(s) of the DISTRIBUTOR/ DEALER being dishonored, AIPL reserves the right to impose
                            a penalty for every instance of Cheque dishonor @ Rs.2000/- Plus the bank charges at actual. AIPL also reserves
                            the right to terminate and cancel the DISTRIBUTOR/ DEALER appointment without any prior notice or
                            intimation what so ever .The company also reserves its right to take legal action against the party for recovery of
                            the entire amount due WITH INTEREST AND ALL LEGAL CHARGES INCURRED BY AIPL.</p>


                        <p>Legal Requirement:</p>
                        <p>It will be responsibility of DISTRIBUTOR/ DEALER to apply for and to maintain in full force and effect all
                            licenses and permissions under the applicable Laws/ Regulations, more particularly Fertilizer Control Order
                            1985(FCO) and the Rules prescribed their under and all other applicable license/s to store/ sell Fertilizers and
                            other Agri. inputs.</p>

                        <p>Confidential Information:</p>
                        <p>Unless expressly authorized in writing, the DISTRIBUTOR/ DEALER agree to use the Confidential Information
                            received from the COMPANY;</p>
                        <ul>
                            <li>(a) Only for the purpose of this Agreement and</li>
                            <li>(b) In accordance with instructions received from time to time</li>
                        </ul>

                        <b>Termination:</b>
                        <p>Appointment as DISTRIBUTOR/DEALER (non-exclusive) is terminable at not less than one month written notice
                            from AIPL and not less than 3 month written notice by the DISTRIBUTOR/ DEALER, provided however, that
                            AIPL reserve the right to terminate the appointment with immediate affecting the event of DISTRIBUTOR/
                            DEALER committing a breach of any of the Terms and Conditions. Such termination will be without prejudice
                            to any other remedy which AIPL may have against DISTRIBUTOR/ DEALER and DISTRIBUTOR/ DEALER
                            shall not be entitled to any compensation or payment of any kind whatsoever on account thereof nor shall AIPL
                            be liable to take back any products sold to DISTRIBUTOR/ DEALER.</p>
                        <p>The appointment of DISTRIBUTOR/ DEALER will automatically stand terminated with immediate effect in
                            the event of:</p>
                        <ul>
                            <li>The DISTRIBUTOR/ DEALER becoming Bankrupt</li>
                            <li>Change in Constitution of DISTRIBUTOR/ DEALER</li>
                            <li>Any Criminal case filed against DISTRIBUTOR/ DEALER</li>
                        </ul>

                        <b>Relationship of Parties:</b>
                        <p>The relation between AIPL and DISTRIBUTOR/ DEALER will be that of principal to principal and not as
                            principal to agent. DISTRIBUTOR/ DEALER shall have no right or authority to enter into any contractual
                            obligations or make any representation in the name of or on behalf of AIPL. AIPL will not be responsible or liable
                            for the acts of DISTRIBUTOR/ DEALER or for any amount due and payable by DISRTRIBUTOR / DEALER
                            to any other party.</p>

                        <b>Force Majeure:</b>
                        <p>The COMPANY shall incur no liability whatsoever if any time it is unable to supply the whole Or any part of the
                            goods for reasons beyond its control including acts of God, Acts of State Government orders or restriction, war
                            like conditions, hostilities etc. In such case AIPL shall be the sole judge to decide and the same will be binding
                            on DISTRIBUTOR/ DEALER.</p>

                        <b>Others:</b>
                        <ul>
                            <li>The products once sold and supplied, shall not to be accepted back by COMPANY under any
                        circumstances. AIPL is not responsible to take back any date expired/damaged/leaky stocks.</li>
                            <li>The DISTRIBUTOR/ DEALER shall not enter into any cash transactions with the staff of the Company.
                        If any such cash transaction is entered into by DISTRIBUTOR/ DEALER, the DISTRIBUTOR/DEALER shall not hold AIPL liable for any loss suffered by them and AIPL will not entertain any claim
                        whatsoever in this regard.</li>
                            <li>DISTRIBUTOR/ DEALER agree to keep proper records of stocks of the COMPANY’S product/s and
                        these records will be open for inspection to AIPL’S representatives as and when required.</li>
                            <li>Arbitration: In the event of any dispute or difference between parties hereto arising out
                        Of this agreement, the same shall be referred to Arbitration as per the provision of the Arbitration and
                        Conciliation Act 1996 and the arbitration proceeding shall be in English and shall be in BHUJ-
                        KACHCHH (Gujarat)</li>
                            <li>Jurisdiction: For any suit or legal proceedings arising out of this appointment only the Courts in
                        BHUJ-KACHCHH (Gujarat) shall be the Court having exclusive jurisdiction to entertain and try the
                        same.</li>
                        </ul>
                        <p>THE PARTY HAS TO SIGN ON EVERY PAGE OF THE AGREEMENT TO AVOID ANY CONFUSION IN THE FUTURE</p>
                    </div>
                </Col>
            </Row>
        </div>
    )
}
